import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-easing',
	templateUrl:'./EasingPluginPage.html',
	styles: [],
	styleUrls:['./EasingPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class EasingPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_561 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>easing-effects</artifactId>
</dependency>
\`\`\``;
	mdContent_562 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:easing-effects:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_563 = `\`\`\`json
"easing": "*"
\`\`\``;
	mdContent_564 = `\`\`\`java
// Use easing effect enum
String easing = JQEasingEffects.easeInOutQuad.toString();

// Apply to element animation
myComponent.setAttribute("data-easing", easing);

// Available easings include:
// easeInQuad, easeOutQuad, easeInOutQuad
// easeInCubic, easeOutCubic, easeInOutCubic
// easeInElastic, easeOutBounce, and 24 more...
\`\`\``;
	mdContent_565 = `\`\`\`java
// Use easing effect enum
String easing = JQEasingEffects.easeInOutQuad.toString();

// Apply to element animation
myComponent.setAttribute("data-easing", easing);

// Available easings include:
// easeInQuad, easeOutQuad, easeInOutQuad
// easeInCubic, easeOutCubic, easeInOutCubic
// easeInElastic, easeOutBounce, and 24 more...
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
